import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { noHtmlPatternValidator } from 'validators/src/rawValidators';
import { isFutureEffectiveDate } from '~/business-logic/billingLogic';
import { DraftStatusType, serviceModel, timeModel } from '~/models';
import { toCustomPageDTO } from '~/models/custom-page/model';
export const makeDraft = (data)=>{
    var _data_clientContactId, _data_legalTermsDocuments, _data_customPages;
    var _data_serviceBundles;
    return {
        id: data.id,
        title: noHtmlPatternValidator(data.title) ? data.title : '',
        clientContactId: (_data_clientContactId = data.clientContactId) !== null && _data_clientContactId !== void 0 ? _data_clientContactId : null,
        isSample: data.isSample,
        lastModifiedOn: Date.now(),
        extraClause: noHtmlPatternValidator(data.extraClause) ? data.extraClause : '',
        requirePaymentMethod: data.requirePaymentMethod,
        allowManualPayments: data.allowManualPayments,
        customNotificationText: data.customNotificationText,
        isExistingCustomer: data.isExistingCustomer,
        netTerms: data.netTerms,
        effectiveDate: data.effectiveDate ? timeModel.toDateStampObject(data.effectiveDate) : null,
        coverLetter: data.coverLetter,
        feeControls: {
            coverCreditCardFees: data.coverCreditCardFees,
            coverDirectDebitFees: false
        },
        legalTermsDocuments: (_data_legalTermsDocuments = data.legalTermsDocuments) !== null && _data_legalTermsDocuments !== void 0 ? _data_legalTermsDocuments : [],
        services: data.services.map(serviceModel.toDTO),
        serviceBundles: ((_data_serviceBundles = data.serviceBundles) === null || _data_serviceBundles === void 0 ? void 0 : _data_serviceBundles.bundles.length) ? {
            bundles: data.serviceBundles.bundles.map((b)=>_object_spread_props(_object_spread({}, b), {
                    services: b.services.map(serviceModel.toDTO)
                }))
        } : undefined,
        amendmentsApprovalMethod: data.amendmentsApprovalMethod,
        invoicesApprovalMethod: data.invoicesApprovalMethod,
        requestAccountantAccess: data.requestAccountantAccess,
        reviewers: data.reviewers,
        introVideo: data.introVideo,
        expirationDate: data.expirationDate,
        metadata: data.metadata,
        linkedRelationshipId: data.linkedRelationshipId,
        templateVariableValues: data.templateVariableValues,
        customPages: ((_data_customPages = data.customPages) !== null && _data_customPages !== void 0 ? _data_customPages : []).map(toCustomPageDTO),
        status: {
            type: DraftStatusType.Active
        }
    };
};
export function hasBilledImmediatelyService(services, effectiveDate, now) {
    if (isFutureEffectiveDate(effectiveDate, now)) return false;
    return services.some((s)=>serviceModel.isBillOnPeriodBeforeNextBilling(s));
}
